import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from 'primevue/config';
import App from "./App.vue";

import BaseIcon from "@/components/utils/BaseIcon.vue";
import ErrorMessage from "@/components/utils/ErrorMessage.vue";
import ErrorSection from "@/components/utils/ErrorSection.vue";
import FormInput from "@/components/utils/FormInput.vue";
import SaveFooter from "@/components/utils/SaveFooter.vue";
import SaveResetFooter from "@/components/utils/SaveResetFooter.vue";

import store from "@/store/index.js";
import { boot } from "@/boot";
import { createAppRouter } from "@/router";

import "@/styles/main.scss";

if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API) {
    const { worker } = await import("@/mocks/browser");
    await worker.start({
        onUnhandledRequest(req) {
            // TODO: parse url into components
            const isAllowed =
                req.url.href.startsWith("https://fonts.gstatic.com") ||
                req.url.href.startsWith("https://localhost.opoint.com");

            if (!isAllowed) {
                throw new Error(`Unhandled request: ${req.url.href}`);
            }
        },
    });
}

const pinia = createPinia();
const app = createApp(App);
app.use(store);
app.use(pinia);
app.use(PrimeVue);
app.component("BaseIcon", BaseIcon);
app.component("ErrorMessage", ErrorMessage);
app.component("ErrorSection", ErrorSection);
app.component("FormInput", FormInput);
app.component("SaveFooter", SaveFooter);
app.component("SaveResetFooter", SaveResetFooter);

const start = async () => {
    // Before the router, whose guards read the stores this fills. Pinia has to
    // be installed already.
    const booted = await boot(store);

    const router = createAppRouter(store, booted);
    app.use(router);

    // Nothing should paint against a route that is still settling.
    await router.isReady().catch(() => undefined);

    app.mount("#app");
};

start().catch((e) => console.error("failed to start", e));
